import {BehaviorSubject} from "rxjs";
import {hookFromSubject, promiseToSubject, ResponseSubjectState} from "./index";
import {BillingApi, BillingSettingCreateDto, BillingSettingEditDto, Configuration} from "../generated-api";
import {getCustomHeaders} from "./user";

const {REACT_APP_API_DOMAIN} = process.env;
const billingApi = new BillingApi(new Configuration({basePath: REACT_APP_API_DOMAIN, getHeaders: getCustomHeaders}));

export const billingSettingsSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBillingSettings = hookFromSubject(billingSettingsSubject);
export const getBillingSettings = () =>
    promiseToSubject(billingApi.apiBillingSettingsGet(), billingSettingsSubject);

export const billingSettingSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBillingSetting = hookFromSubject(billingSettingSubject);
export const getBillingSetting = (guid: string, suppressErrors?: boolean) =>
    promiseToSubject(billingApi.apiBillingSettingsGuidGet({guid}), billingSettingSubject, {suppressErrors});
export const updateBillingSetting = (guid: string, body: BillingSettingEditDto) =>
    promiseToSubject(billingApi.apiBillingSettingsGuidPut({guid}, body), billingSettingSubject);
export const createBillingSetting = (body: BillingSettingCreateDto) =>
    promiseToSubject(billingApi.apiBillingSettingsPost(body), billingSettingSubject);

export const billingSettingDeleteSubject = new BehaviorSubject(new ResponseSubjectState());
export const useBillingSettingDelete = hookFromSubject(billingSettingDeleteSubject);
export const deleteBillingSetting = (guid: string) =>
    promiseToSubject(billingApi.apiBillingSettingsGuidDelete({guid}), billingSettingDeleteSubject);


